import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INDRAApiService } from './api.indra.service';
import { URL_BFM_CREATE_CUSTOMER_ACCOUNT, MOCK_STATUS, MOCK_URL_CUSTOMER_ACCOUNT, URL_BFM_MODIFY_CUSTOMER_ACCOUNT, MOCK_URL_UPGRADE_ACCOUNT_OK, MOCK_URL_UPGRADE_ACCOUNT_ERROR } from '@ibe.config';
import { INDRACustomerAccountRequest, INDRACustomerAccountResponse } from '@ibe.models/customer-account.indra.model.lib';

@Injectable({
	providedIn: 'root'
})
export class INDRACustomerAccountService {

	constructor(private http: HttpClient, private api: INDRAApiService) {
	}

	createCustomerAccount(customer: INDRACustomerAccountRequest) {
		if (MOCK_STATUS.CUSTOMER_ACCOUNT) {
			return this.api.INDRA_get<INDRACustomerAccountResponse>(MOCK_URL_CUSTOMER_ACCOUNT);
		} else {
		    return this.api.INDRA_post<INDRACustomerAccountResponse>(URL_BFM_CREATE_CUSTOMER_ACCOUNT, customer);
		}
	}

	modifyCustomerAccount(customer) {
		if (MOCK_STATUS.UPGRADE_ACCOUNT) {
			return this.api.INDRA_get<any>(MOCK_URL_UPGRADE_ACCOUNT_OK);
			// return this.api.INDRA_get<any>(MOCK_URL_UPGRADE_ACCOUNT_ERROR);
		} else {
		    return this.api.INDRA_post<any>(URL_BFM_MODIFY_CUSTOMER_ACCOUNT, customer);
		}
	}
}

